// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Searchbar_search-bar__6Og3z {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 6rem;
}

.Searchbar_search-bar__search-container__nMaB5 {
  display: flex;
  align-items: center;
  gap: 5rem;
}

.Searchbar_search-bar__controls__yM08f {
  display: flex;
  align-items: center;
  gap: 5rem;
}

@media screen and (min-width: 1024px) and (max-width: 1280px) {
  .Searchbar_search-bar__6Og3z {
    padding-inline: 2rem;
  }

  .Searchbar_search-bar__search-container__nMaB5,
  .Searchbar_search-bar__controls__yM08f {
    gap: 2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Layout/DashboardHeader/Searchbar/Searchbar.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;;IAEE,SAAS;EACX;AACF","sourcesContent":[".search-bar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem 6rem;\n}\n\n.search-bar__search-container {\n  display: flex;\n  align-items: center;\n  gap: 5rem;\n}\n\n.search-bar__controls {\n  display: flex;\n  align-items: center;\n  gap: 5rem;\n}\n\n@media screen and (min-width: 1024px) and (max-width: 1280px) {\n  .search-bar {\n    padding-inline: 2rem;\n  }\n\n  .search-bar__search-container,\n  .search-bar__controls {\n    gap: 2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"search-bar": `Searchbar_search-bar__6Og3z`,
	"search-bar__search-container": `Searchbar_search-bar__search-container__nMaB5`,
	"search-bar__controls": `Searchbar_search-bar__controls__yM08f`
};
export default ___CSS_LOADER_EXPORT___;
